import { Pivot, PivotItem, PivotLinkSize } from "@fluentui/react";
import React, { createContext, useContext } from "react";

import {FlowstationBaseView} from './flowstation/FlowstationBaseView'
import SettingStore from "../store/settingstore";
import { observer } from "mobx-react-lite";
import { FieldBaseView } from "./field/FieldBaseView";
import { WellBaseView } from "./well/WellBaseView";
import { LevelBaseView } from "./level/LevelBaseView";
import { FlowstationFieldBaseView } from "./flowstationfield/FlowstationFieldBaseView";
import { FlowstationCapacityBaseview } from "./flowstationcapacity/FlowstationCapacityBaseview";

const settingStorectx = createContext(SettingStore);
export const WRFMBase = observer(() => {
  //const [itemKey, setItemKey] = useState("1");
  const settingStore = useContext(settingStorectx);
  return (
    
    <Pivot
      linkSize={PivotLinkSize.normal}
      selectedKey={settingStore.dailyProdTabSelKey}
      onLinkClick={(item, ev) => {
        settingStore.dailyProdTabSelKey = item.props.itemKey;
      }}
    >
      <PivotItem headerText="Flowstations" itemKey="1">
    <FlowstationBaseView/>
      </PivotItem>

      <PivotItem headerText="Fields" itemKey="2">
     <FieldBaseView/>
      </PivotItem>
      <PivotItem headerText="Wells" itemKey="3">
   <WellBaseView/>
      </PivotItem>
<PivotItem headerText="Levels" itemKey="4">
   <LevelBaseView/>
      </PivotItem>
      <PivotItem headerText="Flowstation-Field Mapping" itemKey="5">
       <FlowstationFieldBaseView/>
      </PivotItem>
<PivotItem headerText="Flowstation Capacity" itemKey="6">
       <FlowstationCapacityBaseview/>
      </PivotItem>
      
    </Pivot>

  );
});

